<div class="bgimg">

<h2 mat-dialog-title>{{data.title}}</h2>
<mat-dialog-content [innerHTML]="data.content"></mat-dialog-content>
<mat-dialog-actions >
  <button mat-raised-button style="margin: 0px auto;" [mat-dialog-close]="true">Close</button>
  <!-- The mat-dialog-close directive optionally accepts a value as a result for the dialog. -->
  <!-- <button mat-raised-button  [mat-dialog-close]="true">Yes</button> -->
</mat-dialog-actions>
</div>